import { useUpdateEffect } from "hooks";
import { slugify } from "libs";
import { useCallback, useState } from "react";
import { api, useCustomFieldsQuery } from "../../api";

import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";


export const useExportEmployees = () => {
  const [isExporting, setExporting] = useState(false);

  const [selectedCheck, setSelectedCheck] = useState<any[]>(["firstName", "lastName"]);
  const [captureInfo, setCaptureInfo] = useState<any>({
    employees: {
      id: "",
      subArea: "",
      area: ""
    }
  });
  const { data: dataCustomFields } = useCustomFieldsQuery();

  const [trigger, { data, isFetching }] =
    api.endpoints.GetAllEmployees.useLazyQuery();


  function getLongestArray(arrays: string[][]): string[] {
    return arrays.reduce((longest, current) => {
      return current.length > longest.length ? current : longest;
    }, []);
  }
  const customExportSalary = (type: string) => {
    if (!captureInfo) return;
    const normalizedCaptureInfo = Array.isArray(captureInfo) ? captureInfo : [captureInfo];
    setExporting(true);

    if (!normalizedCaptureInfo) return;



    if (selectedCheck.includes("educationRecords") || selectedCheck.includes("children")) {
      const includeEducation = selectedCheck.includes("educationRecords");
      const includeChildren = selectedCheck.includes("children");

      let childrenTitles: string[] = [];
      if (includeChildren) {
        const childrenTitleSets = normalizedCaptureInfo.map((e) => {
          const titles: string[] = [];
          e.employee.children?.forEach((_: any, index: number) => {
            const num = index + 1;
            titles.push(`Nombre hijo ${num}`, `Cumpleaños hijo ${num}`, `Género hijo ${num}`);
          });
          return titles;
        });
        childrenTitles = getLongestArray(childrenTitleSets);
      }

      const cols = [
        "Fecha de cambio",
        "Campo",
        "Mensaje",
        "Sueldo Anterior",
        "Sueldo Actual",
        ...(includeEducation ? ["Nivel de Educacion", "Status de Educacion", "Nombre de Educacion","Profesión"] : []),
        ...selectedCheck.filter(f => f !== "educationRecords" && f !== "children"),
        ...childrenTitles
      ];

      const employees = normalizedCaptureInfo.map((e) => {
        const childrenData = includeChildren
          ? e.employee?.children?.flatMap((child: any) => [
            child.fullName ?? "",
            child.birthDate ?? "",
            child.gender ?? ""
          ]) ?? []
          : [];

        const rows = [
          e.createdAt,
          e.field,
          e.message,
          e.previous,
          e.current,
          ...(includeEducation ? [
            e.employee.educationRecords?.[0]?.level ?? "",
            e.employee.educationRecords?.[0]?.status ?? "",
            e.employee.educationRecords?.[0]?.studyName ?? "",
            e.employee.educationRecords?.[0]?.degreeTitle ?? ""
          ] : []),
          ...selectedCheck
            .filter(f => f !== "educationRecords" && f !== "children")
            .map((field) => {
              const value = e.employee?.[field];
              if (typeof value === "object" && value !== null && "name" in value) return value.name;
              return value ?? "";
            }),
          ...childrenData
        ];

        let employee: any = {};
        for (let i = 0; i < cols.length; i++) {
          employee[cols[i]] = rows[i];
        }
        return employee;
      });

      const sheet = XLSX.utils.json_to_sheet(employees);
      const wb = { Sheets: { data: sheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      if (type === "xlsx") FileSaver.saveAs(blob, "Empleados_Export.xlsx");
      if (type === "csv") FileSaver.saveAs(blob, "Empleados_Export.csv");
    }
    else {
      const cols = [
        "Fecha de cambio",
        "Campo",
        "Mensaje",
        "Sueldo Anterior",
        "Sueldo Actual",
        ...selectedCheck,
      ];

      const employees = normalizedCaptureInfo.map((e) => {
        const rows = [
          e.createdAt,
          e.field,
          e.message,
          e.previous,
          e.current,
          ...selectedCheck.map((field) => {
            return e.employee?.[field]?.name ? e.employee?.[field]?.name : e.employee?.[field] ?? "";
          }),
        ];

        let employee: any = {};
        for (let i = 0; i < cols.length; i++) {
          employee[cols[i]] = rows[i];
        }
        return employee;
      });

      const sheet = XLSX.utils.json_to_sheet(employees);
      const wb = { Sheets: { data: sheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (type === "xlsx") FileSaver.saveAs(blob, "Empleados_Export.xlsx");
      if (type === "csv") FileSaver.saveAs(blob, "Empleados_Export.csv");

    }
    setExporting(false);
  };



  const customExportRole = (type: string) => {
    if (!captureInfo) return;
    const normalizedCaptureInfo = Array.isArray(captureInfo) ? captureInfo : [captureInfo];
    setExporting(true);

    if (!normalizedCaptureInfo) return;

    if (selectedCheck.includes("educationRecords") || selectedCheck.includes("children")) {
      const includeEducation = selectedCheck.includes("educationRecords");
      const includeChildren = selectedCheck.includes("children");

      let childrenTitles: string[] = [];
      if (includeChildren) {
        const childrenTitleSets = normalizedCaptureInfo.map((e) => {
          const titles: string[] = [];
          e.employee.children?.forEach((_: any, index: number) => {
            const num = index + 1;
            titles.push(`nombre hijo ${num}`, `cumpleaños hijo ${num}`, `género hijo ${num}`);
          });
          return titles;
        });
        childrenTitles = getLongestArray(childrenTitleSets);
      }

      const cols = [
        "Fecha de cambio",
        "Campo",
        "Mensaje",
         "Cargo Anterior",
        "Cargo Actual",
        ...(includeEducation ? ["Nivel de Educacion", "Status de Educacion", "Nombre de Educacion","Profesión"] : []),
        ...selectedCheck.filter(f => f !== "educationRecords" && f !== "children"),
        ...childrenTitles
      ];

      const employees = normalizedCaptureInfo.map((e) => {
        const childrenData = includeChildren
          ? e.employee?.children?.flatMap((child: any) => [
            child.fullName ?? "",
            child.birthDate ?? "",
            child.gender ?? ""
          ]) ?? []
          : [];

        const rows = [
          e.createdAt,
          e.field,
          e.message,
          e.previous,
          e.current,
          ...(includeEducation ? [
            e.employee.educationRecords?.[0]?.level ?? "",
            e.employee.educationRecords?.[0]?.status ?? "",
            e.employee.educationRecords?.[0]?.studyName ?? "",
            e.employee.educationRecords?.[0]?.degreeTitle ?? ""
          ] : []),
          ...selectedCheck
            .filter(f => f !== "educationRecords" && f !== "children")
            .map((field) => {
              const value = e.employee?.[field];
              if (typeof value === "object" && value !== null && "name" in value) return value.name;
              return value ?? "";
            }),
          ...childrenData
        ];

        let employee: any = {};
        for (let i = 0; i < cols.length; i++) {
          employee[cols[i]] = rows[i];
        }
        return employee;
      });

      const sheet = XLSX.utils.json_to_sheet(employees);
      const wb = { Sheets: { data: sheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      if (type === "xlsx") FileSaver.saveAs(blob, "Empleados_Export.xlsx");
      if (type === "csv") FileSaver.saveAs(blob, "Empleados_Export.csv");
    } else {
      const cols = [
        "Fecha de cambio",
        "Campo",
        "Mensaje",
        "Cargo Anterior",
        "Cargo Actual",
        ...selectedCheck,
      ];

      const employees = normalizedCaptureInfo.map((e) => {
        const rows = [
          e.createdAt,
          e.field,
          e.message,
          e.previous,
          e.current,
          ...selectedCheck.map((field) => {
            return e.employee?.[field]?.name ? e.employee?.[field]?.name : e.employee?.[field] ?? "";
          }),
        ];

        let employee: any = {};
        for (let i = 0; i < cols.length; i++) {
          employee[cols[i]] = rows[i];
        }
        return employee;
      });

      const sheet = XLSX.utils.json_to_sheet(employees);
      const wb = { Sheets: { data: sheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (type === "xlsx") FileSaver.saveAs(blob, "Empleados_Export.xlsx");
      if (type === "csv") FileSaver.saveAs(blob, "Empleados_Export.csv");

    }
    setExporting(false);
  };


  useUpdateEffect(() => {

    if (!isFetching && dataCustomFields) {
      setExporting(false);
      if (data) {
        // TODO: Problema con cambios en los labels

        const cols = [
          "Primer nombre",
          "Segundo nombre",
          "Primer apellido",
          "Segundo apellido",
          "Tipo de identificación",
          "Identificación",
          "Fecha de nacimiento",
          "Departamento de nacimiento",
          "Dirección de residencia",
          "Ciudad de residencia",
          "Departamento de residencia",
          "Teléfono celular",
          "Teléfono fijo",
          "Estado civil",
          "Fondo de pensión",
          "Eps",
          "Número de cuenta",
          "Tipo de cuenta",
          "Banco",
          "Estudios de primaria",
          "Estudios de secundaria",
          "Estudios universitarios",
          "Estudios de postgrado",
          "Estudios de maestría",
          "Estudios de doctorado",
          "Realizó estudios en",
          "Salario",
          "Bonificación",
          "Email",
          "Contrato",
          "Cargo",
          "Fecha de inicio",
          "Fecha de termino",
          ...dataCustomFields.customFields.map((c) => c.name),
        ];

        const employees = data.employees.map((e) => {

          const rows = [
            e.firstName,
            e.middleName,
            e.lastName,
            e.secondLastName,
            e.idType,
            e.idNumber,
            e.dateBirth,
            e.stateBirth,
            e.address,
            e.city,
            e.state,
            e.cellPhone,
            e.phone,
            e.civilStatus,
            e.pensionFund,
            e.eps,
            e.accountNumber,
            e.accountType,
            e.accountBank,
            e.hasElementarySchool,
            e.hasHighSchool,
            e.hasUniversity,
            e.hasGraduateDegree,
            e.hasMastersDegree,
            e.hasDoctorateDegree,
            e.whereStudy,
            e.salary,
            e.bonus,
            e.email,
            e.contract.name,
            e.position.name,
            e.dateStart,
            e.dateEnd,
            ...dataCustomFields.customFields.map(
              (c) => e.custom[slugify(c.name)]
            ),
          ];

          let employee: any = {};
          for (let i = 0; i < cols.length; i++) {
            employee[cols[i]] = rows[i];
          }

          return employee;
        });

        const sheet = XLSX.utils.json_to_sheet(employees);
        const wb = { Sheets: { data: sheet }, SheetNames: ["data"] };
        const excelBuffer: ArrayBuffer = XLSX.write(wb, {
          bookType: "xlsx",
          type: "array",
        });

        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, "Empleados.xlsx");
      }
    }
  }, [isFetching, setExporting, dataCustomFields]);

  const initialExport = useCallback(
    (active?: boolean) => {
      setExporting(true);
      trigger({ active });
    },
    [setExporting, trigger]
  );


  const relationData = [
    { name: "Primer nombre", dato: "firstName" },
    { name: "Segundo nombre", dato: "middleName" },
    { name: "Primer apellido", dato: "lastName" },
    { name: "Segundo apellido", dato: "secondLastName" },
    { name: "Tipo de identificación", dato: "idType" },
    { name: "Identificación", dato: "idNumber" },
    { name: "Fecha de nacimiento", dato: "dateBirth" },
    { name: "Departamento de nacimiento", dato: "stateBirth" },
    { name: "Dirección de residencia", dato: "address" },
    { name: "Ciudad de residencia", dato: "city" },
    { name: "Departamento de residencia", dato: "state" },
    { name: "Teléfono celular", dato: "cellPhone" },
    { name: "Teléfono fijo", dato: "phone" },
    { name: "Estado civil", dato: "civilStatus" },
    { name: "Marca de computador", dato: "computerBrand" },
    { name: "Serial de Computador", dato: "computerSerialNumber" },
    { name: "Fondo de pensión", dato: "pensionFund" },
    { name: "Eps", dato: "eps" },
    { name: "Número de cuenta", dato: "accountNumber" },
    { name: "Tipo de cuenta", dato: "accountType" },
    { name: "Banco", dato: "accountBank" },
    { name: "Realizó estudios en", dato: "whereStudy" },
    { name: "Salario", dato: "salary" },
    { name: "Bonificación", dato: "bonus" },
    { name: "Email", dato: "personalEmail" },
    { name: "Contrato", dato: "contract" },
    { name: "Area", dato: "position" },
    { name: "Fecha de inicio", dato: "dateStart" },
    { name: "Fecha de termino", dato: "dateEnd" },
    { name: "Datos de Hijos", dato: "children" },
    { name: "Datos de Educacion", dato: "educationRecords" }
  ]

  relationData.sort((a, b) => a.name.localeCompare(b.name));
  return { isExporting, relationData, initialExport, setCaptureInfo, customExportSalary, customExportRole, selectedCheck, captureInfo, setSelectedCheck };
};
